module.exports = __webpack_public_path__ + "img/playicon.b66f37d9.png";